export default __webpack_public_path__ + "static/media/car.37c9c76c.svg";